import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { ContactHero } from '@/components/contact/contact-hero'
import { ContactPanel } from '@/components/contact/contact-panel'
import { ContactFaq } from '@/components/contact/contact-faq'

import { media } from '@/constants/media'

const Contact: FC = (): ReactNode => {
    return (
        <Layout theme='light'>
            <Seo
                title='Contact'
                description='Book a 30-minute call or send us a message. We respond within 24 hours.'
                ogImage={media.callout}
            />

            <ContactHero />
            <ContactPanel />
            <ContactFaq />
        </Layout>
    )
}

export default Contact
